/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import StakeholdersPageQuery$parameters, {
	type StakeholdersPageQuery,
} from './ui/__generated__/StakeholdersPageQuery.graphql';

type CommunicationsStakeholdersEntrypointComponent = EntryPointComponent<
	{
		StakeholdersPageQuery: StakeholdersPageQuery;
	},
	{},
	{},
	{}
>;

export const communicationsStakeholdersEntrypoint: EntryPoint<
	CommunicationsStakeholdersEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CommunicationsStakeholdersEntrypointComponent>(
		/* webpackChunkName: "async-communications-stakeholders-entrypoint" */ './ui/StakeholdersPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const filter = context.query.filter ? JSON.parse(context.query.filter) : null;
		const search = context.query.search
			? {
					searchField: 'EMAIL_ID' as const, // STATIC AS WE SUPPORT ONLY EMAIL ID SEARCH FOR NOW
					searchValue: context.query.search,
				}
			: null;
		return {
			queries: {
				StakeholdersPageQuery: {
					parameters: StakeholdersPageQuery$parameters,
					variables: {
						filter,
						search,
						first: 30,
						cloudId: tenantContext.cloudId,
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
		};
	},
});
